
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import accountx from '../../store/modules/accountx';
import mwx from '../../store/modules/mediumwarex';
import { AccountMinimumData } from '../../store/models.def';

@Component({
	components: {},
})
export default class AllAccounts extends Vue {
	public get currentAccountId(): string | null {
		const accountId = this.$route.params.accountId;
		accountx.updateCurrentAccountId(accountId);
		return accountId;
	}

	public get allAccounts() {
		if (!this.onlyExpired) {
			return mwx.allAccounts;
		}
		const list = mwx.allAccounts.filter((acc) => acc.expiryTime < Date.now());
		list.sort((a, b) => b.expiryTime - a.expiryTime);
		return list;
	}

	public get filteredAccounts(): AccountMinimumData[] {
		if (!this.searchString) {
			return this.allAccounts;
		}
		const keywords = this.searchString
			.toLowerCase()
			.split(/,\s*/g)
			.map((s) => s.trim())
			.filter((s) => s);

		return this.allAccounts.filter(
			(data) =>
				this.match(keywords, data.companyName) ||
				this.match(keywords, data.companyRemark) ||
				this.match(keywords, data.accountId),
		);
	}

	public searchString: string = '';

	public onlyExpired = false;
	public match(keywords: string[], target: string) {
		const text = target.toLowerCase();
		for (const keyword of keywords) {
			if (text.indexOf(keyword) !== -1) {
				return true;
			}
		}
		return false;
	}
}
